import { ProgramDescriptionAccordion } from '@components/buzzkuri/shared/uiParts/accordion/ProgramDescription'
import { ProgramFeatureNumbers } from '@type/buzzkuri/program-detail'
import { ProgramLabel } from '@type/buzzkuri/programs'
import React from 'react'
import { ProgramFeatureContent } from './Content'

type Props = {
  feature: ProgramFeatureNumbers
  objectives: ProgramLabel[]
  tags: ProgramLabel[]
}

export const ProgramFeature = ({
  feature,
  objectives,
  tags,
}: Props): JSX.Element => {
  return (
    <div className="w-[87.2vw] lg:w-[62.6vw]">
      <ProgramDescriptionAccordion title="このプログラムの特徴">
        <div className="flex justify-center pt-[6vw] lg:pt-[3vw] lg:pr-[4.7vw] pb-[10.7vw] lg:pb-[4.4vw] lg:pl-[3.2vw] bg-[#F7F6F5]">
          <ProgramFeatureContent {...{ feature, objectives, tags }} />
        </div>
      </ProgramDescriptionAccordion>
    </div>
  )
}
